import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';
import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {ExperienceLevel} from '@/common/api/api-raw-types';

export class TjmRecommendationService {
    async retrieveTjmRecommendation(category: string, experienceLevel: ExperienceLevel): Promise<HttpServiceResponse<number>> {
        return await context.httpService.get<number>(context.registry.entries.tjmRecommendation(), {
            category,
            experienceLevel,
        });
    }
}
